import dayjs from 'dayjs'
import account, { logout } from '@/store/account'

export async function res2json(r) {
  if (r.status === 401) {
    logout()
    const url = account().game_code ? `/login/${account().game_code}` : '/welcome'
    if (document.location.pathname !== url) {
      document.location.href = url
    }
    return
  }
  r.data = await r.json()
  return r
}

export const hourPadStart = (val) => val.toString().padStart(2, '0')

export const expiresDays = (unixepoch) => Math.max(Math.ceil(dayjs(unixepoch * 1000).diff(new Date, 'h') / 24), 0)
